<div class="login-modal" >
  <section class="login-section">
  <div class="overlay" (click)="DismissModal($event)"></div>
  <div class="login-section-inner">
    <div class="close-icon-container">
      <img src="../../../../assets/images/svgs/close-white.svg" class="close-icon" (click)="DismissModal($event)" />
    </div>
    <div class="login-right">
      <div>
        <form class="form-card" [formGroup]="loginForm">
          <div class="row">            
            <div class="col-md-12">
              <div class="form-group">
                <div class="section-relative">
                  <input type="email" formControlName="userName" class="form-control" id="InputEmail"
                    aria-describedby="emailHelp" placeholder="Enter Email" />
                  <img src="../../../../assets/images/user.svg" class="user-icon" />

                  <div *ngIf="hasError('userName', 'required') && submitted" class="invalid-Validation">
                    Email is required
                  </div>
                  <div *ngIf="hasError('userName', 'email') && submitted" class="invalid-Validation">
                    Invalid Email
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <div class="section-relative">
                  <input id="exampleInputPassword1" formControlName="password" class="form-control" pTooltip="Passwords must contain at least eight characters." tooltipPosition="left" placeholder="Enter Password"
                    type="password" required />
                  <img src="../../../../assets/images/password.svg" class="user-icon pass-icon" />

                  <div *ngIf="hasError('password', 'required') && submitted" class="invalid-Validation">
                    Password is required
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="remember-sec">
                <div class="forgot-pass">
                  <a routerLink="/forgotpassword">Forgot Password</a>
                </div>

                <label class="container">Remember me
                  <input type="checkbox" formControlName="remember" />
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
            <div class="col-md-12">
              <div class="btn-login-sec">                
                <button class="btn btn-signIn btn-signUp" (click)="Register($event)">
                  REGISTER
                </button>
                <button class="btn btn-signIn" type="submit" (click)="Login()">
                  SIGN IN
                </button>
              </div>
            </div>           
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
</div>
